import { Box, CircularProgress } from '@mui/material';

export default function LoadingContent(props) {
  return (
    <Box display={'flex'} justifyContent={'center'} {...props}>
      <CircularProgress />
    </Box>
  );
}
